import React, { useEffect, useState } from 'react';
import client from '../../../utils/prismicHelpers';
import * as queries from "../../../utils/prismicQueries";
import './ventures.css'

const VentureFund = () => {
    const [ventureFund, setVentureFund] = useState(null);
    useEffect(() => {
        client
            .query({
                query: queries.ventureFund,
            })
            .then((response) => {
                const ventureDoc = response.data.allVenture_funds.edges[0].node;
                setVentureFund(ventureDoc);


            })
            .catch((error) => {
                console.error(error);
            });
    });
   
   
    return (

        <div className="inno-fellow-container">
            <div className=" pt-5">

                <p>{ventureFund?.des1}</p>
                <p >{ventureFund?.des2}</p>
               

                <div className=" disclaimer-body">
                    <div className=" text-start pt-5">
                        <p><span className="pt-5  secondary-text">Disclaimer: </span> Currently under SEBI approval process.</p>
                      
                    </div>
                </div>


            </div>
        </div>

    );
};

export default VentureFund;